const mapping: Record<string, string> = {
  id: 's=>s.Id',
  name: 's=>s.Name',
  parentId: 's=>s.ParentId',
}

export const mapSortSchemeParam = (key: string) => mapping[key]
